var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribeshape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 549,
    viewBox: "0 0 85 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16403",
    "data-name": "Rectangle 16403",
    width: 85,
    height: 549,
    transform: "translate(1835 11938)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1638",
    "data-name": "Rectangle 1638",
    width: 491.341,
    height: 299.94,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_780",
    "data-name": "Mask Group 780",
    transform: "translate(-1835 -11938)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60748",
    "data-name": "Group 60748",
    transform: "matrix(-0.391, -0.921, 0.921, -0.391, 1839.059, 12500.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17495",
    "data-name": "Group 17495",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17494",
    "data-name": "Group 17494",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17493",
    "data-name": "Group 17493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17492",
    "data-name": "Group 17492",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M491.147,331.3a.176.176,0,0,1-.133-.051L436.375,274.2l-93.692,1.739a.2.2,0,0,1-.178-.122L300.871,171.774,237.8,152.032l-58.272-9.178,18.8,66.927a.189.189,0,0,1-.057.2.2.2,0,0,1-.2.038L87.376,166.524a.2.2,0,0,1-.12-.148L72.976,87.544.285,124.338a.2.2,0,0,1-.266-.09.2.2,0,0,1,.089-.263l72.926-36.91a.214.214,0,0,1,.178,0,.19.19,0,0,1,.108.141l14.3,78.98,110.229,43.309-18.781-66.837a.22.22,0,0,1,.044-.186.233.233,0,0,1,.178-.064l58.6,9.229,63.186,19.78a.206.206,0,0,1,.127.115l41.621,104,93.635-1.739a.2.2,0,0,1,.133.051l54.69,57.1a.19.19,0,0,1,.006.276.179.179,0,0,1-.14.064",
    transform: "translate(0 -45.204)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M139.921,259.307a.2.2,0,0,1-.19-.16l-14.089-63.372-.051.032L16.205,254.134a.2.2,0,0,1-.266-.083.193.193,0,0,1,.082-.263l109.36-58.314.152-.16-12.593-56.646a.194.194,0,0,1,.12-.231l102.88-38.226a.2.2,0,0,1,.209.327l-90.185,94.891,14.146,63.635a.2.2,0,0,1-.146.244h-.044M113.359,138.744l12.5,56.216,89.425-94.076Z",
    transform: "translate(85.007 26.013)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M11.492,274.8h-.013a.2.2,0,0,1-.184-.212l6.512-97.535a.2.2,0,0,1,.165-.186L137.7,155.131l39.668-57.923a.188.188,0,0,1,.273-.051.205.205,0,0,1,.051.276l-39.719,57.993a.213.213,0,0,1-.127.083L18.188,177.228l-6.5,97.387a.2.2,0,0,1-.2.186",
    transform: "translate(60.324 9.319)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M77.237,165.022a.154.154,0,0,1-.108-.032L.3,116.219a.2.2,0,0,1-.063-.27.184.184,0,0,1,.273-.058l76.578,48.6,9.067-64.944a.2.2,0,1,1,.387.051l-9.112,65.246a.182.182,0,0,1-.114.154l-.076.019",
    transform: "translate(1.097 21.557)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M.811,236.139a.2.2,0,0,1-.1-.026.2.2,0,0,1-.063-.276l68.918-113.2L10.792,80.893a.2.2,0,0,1-.051-.27.188.188,0,0,1,.273-.051l58.932,41.846a.2.2,0,0,1,.051.27L.976,236.049a.2.2,0,0,1-.165.09",
    transform: "translate(3.291 -80.534)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M119.968,213.414a.2.2,0,0,1-.178-.109L69.767,110.058,1.914,167.89a.19.19,0,0,1-.273-.019.2.2,0,0,1,.019-.282L69.7,109.6a.183.183,0,0,1,.171-.045.2.2,0,0,1,.133.1l50.137,103.478a.2.2,0,0,1-.089.263l-.089.019",
    transform: "translate(8.497 76.637)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M106.577,187.49l-.057-.013L65.5,175.617a.191.191,0,0,1-.12-.1.2.2,0,0,1-.006-.16l21.812-59.078a.193.193,0,0,1,.184-.122.214.214,0,0,1,.184.141l19.206,70.939a.191.191,0,0,1-.044.2.2.2,0,0,1-.14.058M65.818,175.3,106.292,187,87.339,116.95Z",
    transform: "translate(349.081 112.45)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M299.391,259.307l-.051-.006a.2.2,0,0,1-.133-.116l-22.313-54.1-14.812,43.014a.2.2,0,0,1-.2.128.19.19,0,0,1-.178-.16L235.323,102.155,228.887,251a.2.2,0,0,1-.108.167.234.234,0,0,1-.2-.013l-83.965-55.343L12.469,160.565a.2.2,0,0,1-.139-.244.2.2,0,0,1,.241-.141l132.174,35.261.057.026,83.711,55.169,6.493-150.246a.2.2,0,0,1,.184-.186.179.179,0,0,1,.209.16l26.555,146.89,14.736-42.789a.191.191,0,0,1,.178-.135c.082.026.158.045.19.122l22.415,54.354,71.049-56.177a.186.186,0,0,1,.273.045.2.2,0,0,1-.044.276L299.5,259.268a.188.188,0,0,1-.114.039",
    transform: "translate(65.815 26.014)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M26.741,172.769a.189.189,0,0,1-.114-.038.2.2,0,0,1-.044-.276l42-57.339a.191.191,0,0,1,.171-.077l132.174,8.9a.189.189,0,0,1,.171.135.2.2,0,0,1-.044.205l-48.184,46.467a.2.2,0,0,1-.273-.289L200.46,124.3,68.831,115.437,26.9,172.686a.189.189,0,0,1-.159.083",
    transform: "translate(141.773 106.409)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M18.166,218.592a.207.207,0,0,1-.12-.039.2.2,0,0,1-.038-.276l84-112.046a.2.2,0,0,1,.241-.058l144.545,65.907a.2.2,0,1,1-.159.359L102.227,106.6l-83.9,111.918a.209.209,0,0,1-.159.077",
    transform: "translate(95.975 58.282)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M68.022,185.464a.217.217,0,0,1-.146-.064.2.2,0,0,1,.019-.282l100.47-88.838L77.349,119.8l-75.2,21.417a.18.18,0,0,1-.241-.135.2.2,0,0,1,.133-.244l75.208-21.423,91.815-23.727a.2.2,0,0,1,.222.1.208.208,0,0,1-.044.237L68.149,185.419a.182.182,0,0,1-.127.045",
    transform: "translate(10.148 1.526)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M18.166,282.588l-.063-.013a.194.194,0,0,1-.12-.25L83.1,95.81a.189.189,0,0,1,.247-.116.2.2,0,0,1,.12.25L18.35,282.46a.193.193,0,0,1-.184.128",
    transform: "translate(95.975 1.532)",
    fill: "#bee5e2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M49.734,101.29a1.221,1.221,0,1,1-1.224-1.239,1.232,1.232,0,0,1,1.224,1.239",
    transform: "translate(252.583 25.203)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M56.28,117.5a1.221,1.221,0,1,1-1.224-1.239A1.232,1.232,0,0,1,56.28,117.5",
    transform: "translate(287.544 113.04)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M71.183,117.32a1.221,1.221,0,1,1-1.224-1.239,1.227,1.227,0,0,1,1.224,1.239",
    transform: "translate(367.139 112.054)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M35.486,116.154a1.221,1.221,0,1,1-1.224-1.239,1.232,1.232,0,0,1,1.224,1.239",
    transform: "translate(176.487 105.737)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M33.484,107.22a1.221,1.221,0,1,1-1.217-1.239,1.231,1.231,0,0,1,1.217,1.239",
    transform: "translate(165.795 57.332)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M14.576,110.647a1.221,1.221,0,1,1-1.224-1.239,1.232,1.232,0,0,1,1.224,1.239",
    transform: "translate(64.811 75.9)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M30.519,96.74A1.221,1.221,0,1,1,29.3,95.508a1.231,1.231,0,0,1,1.217,1.232",
    transform: "translate(149.96 0.589)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M16.04,100.443A1.221,1.221,0,1,1,14.816,99.2a1.232,1.232,0,0,1,1.224,1.239",
    transform: "translate(72.63 20.614)",
    fill: "#bee5e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M13.806,88.153a1.221,1.221,0,1,1-1.224-1.232,1.232,1.232,0,0,1,1.224,1.232",
    transform: "translate(60.698 -45.935)",
    fill: "#bee5e2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeshape);
export default __webpack_public_path__ + "static/media/subscribeshape.72089f523dc1ac28a0f60a7a0d34b21e.svg";
export { ForwardRef as ReactComponent };